import React, { useEffect, useState } from "react";
import { fetchReportGoals } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface GoalsCompletedMetricState {
  data?: any[];
  useDatePicker?: boolean;
  startDate?: string;
  endDate?: string;
}

export const GoalsCompletedMetric = ({ data, useDatePicker = false, startDate, endDate }: GoalsCompletedMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [completed, setCompleted] = useState<string>();

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setCompleted(data.toString());
        setIsLoading(false);
      } else {
        //default dates
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        var start = starting.toISOString().slice(0, 10);
        var end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getGoalData(start!, end!);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [data, startDate, endDate]);

  const getGoalData = async (start: string, end: string) => {
    fetchReportGoals(start, end)
      .then((res: any) => {
        const data = res[0].data;
        setCompleted(data.length.toString());
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return <SingleCardMetric title={"Goals Completed"} total={completed} isLoading={isLoading} />;
};
